import ModalDuplicateProject from './ModalDuplicateProject';

export default ModalDuplicateProject;
